/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UboDeclarationBeneficiaryResource } from './';
import {
    UboDeclarationBeneficiaryResourceFromJSON,
    UboDeclarationBeneficiaryResourceFromJSONTyped,
    UboDeclarationBeneficiaryResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UboDeclarationRequest
 */
export interface UboDeclarationRequest {
    /**
     * 
     * @type {Array<UboDeclarationBeneficiaryResource>}
     * @memberof UboDeclarationRequest
     */
    ultimateBeneficialOwners: Array<UboDeclarationBeneficiaryResource>;
}

/**
 * Check if a given object implements the UboDeclarationRequest interface.
 */
export function instanceOfUboDeclarationRequest(value: object): value is UboDeclarationRequest {
    if (!('ultimateBeneficialOwners' in value) || value['ultimateBeneficialOwners'] === undefined) return false;
    return true;
}

export function UboDeclarationRequestFromJSON(json: any): UboDeclarationRequest {
    return UboDeclarationRequestFromJSONTyped(json, false);
}

export function UboDeclarationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ultimateBeneficialOwners': ((json['ultimateBeneficialOwners'] as Array<any>).map(UboDeclarationBeneficiaryResourceFromJSON)),
    };
}

export function UboDeclarationRequestToJSON(value?: UboDeclarationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ultimateBeneficialOwners': ((value['ultimateBeneficialOwners'] as Array<any>).map((v) => UboDeclarationBeneficiaryResourceToJSON(v))),
    };
}

